module.exports = __webpack_public_path__ + "img/logo.352b8717.png";